<template>
  <div>
    <z-header :title="title" :actions="actions"></z-header>
    <div>
      <p class="has-text-right">
        <button @click="exportToCSV" :class="{'is-loading' : isLoading ,'is-primary': true, button: true }" :disabled="data.length == 0">Exportar para CSV</button>
      </p>
    </div>
    <section>
      <h5 class="title is-5">Filtrar</h5>
      <div class="columns is-multiline is-mobile">
        <div class="column is-half-mobile is-one-third-desktop">
          <b-field label="por CPF/CNPJ" label-position="on-border">
            <b-input
              v-model="filters.document"
              name="document"
              maxlength="18"
              :has-counter="false"
              v-cleave="masks.CNPJ"
              @input.native="
                cleaveRefresh($event, { ranges: { 0: 'CPF', 15: 'CNPJ' } })
              "
            />
          </b-field>
        </div>
        <div class="column is-half-mobile is-one-third-desktop">
          <b-field label="por Nome" label-position="on-border">
            <b-input v-model="filters.name" name="name" />
          </b-field>
        </div>
        <div class="column is-half-mobile is-one-third-desktop">
          <b-field label="por Departamento" label-position="on-border">
            <b-input v-model="filters.department" name="department" />
          </b-field>
        </div>
      </div>
    </section>
    <section>
      <b-table
        :data="filter"
        :hoverable="true"
        :striped="true"
        :row-class="rowClass"
        :mobile-cards="true"
        :loading="isLoading"
        @click="view"
        default-sort="id"
        sort-icon="sort-up"
        :paginated="true"
        :pagination-simple="true"
        aria-next-label="Proxima página"
        aria-previous-label="Página anterior"
        aria-page-label="Página"
        aria-current-label="Página atual"
      >
        <template slot-scope="props">
          <b-table-column field="document" label="CPF/CNPJ" sortable>{{
            props.row.document | document
          }}</b-table-column>

          <b-table-column field="name" label="Nome" sortable>{{
            props.row.name
          }}</b-table-column>

          <b-table-column field="department" label="Departamento" sortable>{{
            props.row.department
          }}</b-table-column>

          <b-table-column field="externalCode" label="Cód. interno" sortable>{{
            props.row.externalCode
          }}</b-table-column>

          <b-table-column field="restrictionGroup" label="Restrição" sortable>{{
            (props.row.restrictionGroup || {}).title || "Nenhuma"
          }}</b-table-column>
        </template>
        <template slot="empty">
          <section v-if="!isLoading" class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="sad-tear" size="is-large"></b-icon>
              </p>
              <p>Sem dados de motoristas.</p>
            </div>
          </section>
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>
import ZHeader from "../../layout/Header";
import { format } from "date-fns";
import { downloadCSV } from "../../services/downloadCSV";
import cleave, { cleaveRefresh, masks } from "../../directives/cleave.js";
import fleet from "../../services/fleetUser";

import "../../filters/registration-plate";
import "../../filters/document";

export default {
  data() {
    return {
      title: "Motoristas",
      actions: [
        {
          label: "Cadastrar",
          route: "motoristas/novo",
          class: "is-primary"
        }
      ],
      masks,
      cleaveRefresh,
      data: [],
      filters: {
        document: "",
        name: "",
        department: ""
      },
      isLoading: false,
      firstLoad: true
    };
  },
  directives: {
    cleave
  },
  mounted() {
    this.loadData();
    this.setFilterList();
  },
  computed: {
    filter: function() {
      const cleanDocument = this.filters.document
        .toUpperCase()
        .replace(/[^0-9A-Z]/g, "");
      const documentRegExp = new RegExp(cleanDocument, "i");
      const nameRegExp = new RegExp(this.filters.name, "i");
      const departmentRegExp = new RegExp(this.filters.department, "i");

      return this.data.filter(
        value =>
          value.document.match(documentRegExp) &&
          (value.name || "").match(nameRegExp) &&
          (value.department || "").match(departmentRegExp)
      );
    }
  },
  methods: {
    loadData() {
      this.isLoading = true;
      fleet.all().then(data => {
        this.isLoading = false;
        this.data = data;
      });
    },
    view(data) {
      this.$router.push(`motoristas/${data.id}`);
    },

    rowClass() {
      return "is-clickable";
    },
    exportToCSV(e) {
      e.preventDefault();

      const header = {
        document: "CPF",
        name: "NOME",
        department: "DEPARTAMENTO",
        externalCode: "CÓDIGO INTERNO",
        restrictionGroup: "RESTRICAO"
      };
      const allowedCols = Object.keys(header);

      const csv = this.data.map(row =>
        allowedCols.map(col => {
          switch (col) {
            case document:
              return document(row.document);
            case "restrictionGroup":
              return (row.restrictionGroup || {}).title || "nenhuma";
            default:
              return row[col]
          }
        }).join(",")
      );
      const file = `${allowedCols.map(h => header[h]).join(",")}\n${csv.join("\n")}`;
      const filename = `extrato-motoristas-zul-corporate-${format(new Date(), "dd-MM-yyyy-HH-mm")}`;
      downloadCSV(file, `${filename}.csv`);
    },
    setFilterList() {},
    filterData() {}
  },
  components: {
    ZHeader
  }
};
</script>

<style lang="scss"></style>
